module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Total))]), _vm._v(" "), _c('p', [_vm._v("Registrations")])]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Total - _vm.Arrived))]), _vm._v(" "), _c('p', [_vm._v("Not Arrived")])]), _vm._v(" "), _c('div', {
    staticClass: "dash"
  }, [_c('h3', [_vm._v(_vm._s(_vm.Arrived))]), _vm._v(" "), _c('p', [_vm._v("Arrived")])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h3', [_vm._v("Category Wise Total")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.stats), function(S) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(S._id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(S.arrived))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(S.notArrived))])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('br'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPleaseWait) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('h1', [_vm._v(_vm._s(_vm.alertMessage))])]) : _vm._e()])], 1), _vm._v(" "), (_vm.showLoading) ? _c('div', {
    staticClass: "row loadingContainer"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-5x fa-fw loading"
  })]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showTable) ? _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row box-body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive",
    attrs: {
      "id": "Feedbacks"
    }
  }, [_c('table', {
    staticClass: "display table table-bordered table-striped dataTable wrap",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("New UID")]), _vm._v(" "), _c('th', [_vm._v("On The Spot")]), _vm._v(" "), _c('th', [_vm._v("Selfie")]), _vm._v(" "), _vm._l((_vm.tableHeader.customFields.formFields), function(x) {
    return [_c('th', [_vm._v(_vm._s(_vm.capitalizeFirstLetter(x.label)))])]
  }), _vm._v(" "), _c('th', [_vm._v("QR Code")]), _vm._v(" "), _c('th', [_vm._v("ID Card")]), _vm._v(" "), _c('th', [_vm._v("Send Whatsapp")]), _vm._v(" "), _c('th', [_vm._v("Send Gen ID Card Link")]), _vm._v(" "), _c('th', [_vm._v("Current Status")]), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.List), function(S, index) {
    return [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(" " + _vm._s(S.customFields.newUid) + " ")]), _vm._v(" "), _c('td', [('S.customFields.batch' == 'WalkIn') ? _c('p', [_vm._v("Yes")]) : _vm._e(), _vm._v(" "), ('S.customFields.batch' != 'WalkIn') ? _c('p', [_vm._v("No")]) : _vm._e()]), _vm._v(" "), _c('td'), _vm._v(" "), _vm._l((S.customFields.rsvpInfo), function(value, key) {
      return [_c('td', [(typeof value === 'string' && value.includes('https://firebasestorage')) ? [_c('a', {
        attrs: {
          "href": value,
          "target": "_blank"
        }
      }, [_vm._v("View")])] : [_vm._v("\n                                " + _vm._s(value) + "\n                              ")]], 2)]
    }), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('a', {
      attrs: {
        "href": S.eTicketUrl,
        "target": "_blank"
      }
    }, [_vm._v("View")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.sendWhatsappPrompt(S);
        }
      }
    }, [_vm._v("\n                        Send Whatsapp\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-outline-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.sendIDCardPrompt(S);
        }
      }
    }, [_vm._v("\n                        Send Link\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1 text-center"
    }, [(S.status == '') ? _c('p', {
      attrs: {
        "id": "labelNotArrived"
      }
    }, [_vm._v("Not Arrived")]) : _vm._e(), _vm._v(" "), (S.status != '') ? _c('p', {
      attrs: {
        "id": "labelGreen"
      }
    }, [_vm._v(" " + _vm._s(_vm.capitalizeFirstLetter(S.status)) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editIDCard(S);
        }
      }
    }, [_vm._v("\n                        Edit\n                    ")])])], 2)]
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalCenterTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.editInfo), function(value, key) {
    return _c('div', {
      key: key,
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(key)))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editInfo[key]),
        expression: "editInfo[key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": key,
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.editInfo[key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editInfo, key, $event.target.value)
        }
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.editSave()
      }
    }
  }, [_vm._v("Save & Generate ID Card")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showLoading2) ? _c('p', [_vm._v("Please wait...")]) : _vm._e()])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Arrived")]), _vm._v(" "), _c('th', [_vm._v("Not Arrived")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalCenterTitle"
    }
  }, [_vm._v("Edit ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Important:")]), _c('br'), _vm._v("\n              Photo, UID, Name, Mobile, Email & DOB will be displayed on the ID Card.\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4de35fdf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Registrations.vue
// module id = 1485
// module chunks = 1